<ng-container *ngrxLet="{view:selectCurrentView$} as data">
<app-header-step [user]="user"
                 [queryParams]="queryParams"
                 step="2"
                 (updateInformation)="updateInformation(0)"></app-header-step>

<app-tile (onSelectTile)="selectTile($event)" [tile$]="selectTilesViews$"></app-tile>

<app-dynamic-component
    [components]="components"
    [queryParams]="queryParams"
    [user]="user"
    (onChange)="onChange($event)"
    [element]="data.view"></app-dynamic-component>
</ng-container>
